import {ZoppmPodmienkaPublicResponse} from "/@src/client-public";

type GetPodmienkyDataReturnType = [ZoppmPodmienkaPublicResponse | undefined, number | undefined];

/** Najde data podmienky podla nazvu jej typu. */
export const getPodmienkyData = (
  podmienky: ReadonlyArray<ZoppmPodmienkaPublicResponse>,
  specRefName: string
): GetPodmienkyDataReturnType => {
  const index = podmienky.findIndex((podmienka) => podmienka.zoppmPodmienkaSpecRef?.typ === specRefName)
  return index >= 0 ? [podmienky[index], index] : [undefined, undefined]
}
